import { render, staticRenderFns } from "./BalanceGlobal.vue?vue&type=template&id=5cb51acf&"
import script from "./BalanceGlobal.vue?vue&type=script&lang=js&"
export * from "./BalanceGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports